//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    products: { type: Array, required: true },
    title: { type: String, default: 'Explore the Collection' },
    cartMode: { type: Boolean, default: false },
    productPageMode: { type: Boolean, default: false }
  },
  computed: {
    sliderSettings () {
      if (this.productPageMode) {
        return {
          disableOnDesktop: false,
          centerMode: false,
          centerPadding: '0px',
          slidesToShow: 3,
          slidesToScroll: 1,
          responsive: [{
            breakpoint: 800,
            settings: { slidesToShow: 2 }
          }, {
            breakpoint: 600,
            settings: { slidesToShow: 1 }
          }]
        }
      } else {
        return {
          disableOnDesktop: true
        }
      }
    }
  }
}
